import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import reportWebVitals from './reportWebVitals';
import Router from './Router';
import { Provider } from 'react-redux';
import store from './stores';
import LifecycleGuard from './features/LifecycleGuard';
import { ToastProvider } from './hooks/useToast';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ToastProvider>
      <LifecycleGuard />
      <Router />
    </ToastProvider>
  </Provider>
);

// ✅ WebView에서 evaluateJavascript로 호출할 전역 함수 등록
window.kakaoLoginComplete = (code) => {
  console.log("✅ WebView에서 받은 카카오 로그인 코드:", code);
  alert(`로그인 인증 코드: ${code}`); // 또는 화면에 표시
  // 여기에 토큰 요청 또는 Redux dispatch 등 자유롭게 처리 가능
  // 예: axios.post('/api/kakao/token', { code }) ...
};

reportWebVitals();
